"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCallSkeleton = function SvgCallSkeleton(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207 40"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#919499",
    cx: 20,
    cy: 20,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.428 15.773 9.643-9.633m2.87 9.633 9.643-9.633m2.87 9.633 9.644-9.633m2.87 9.633 9.643-9.633m2.87 9.633 9.643-9.633m3.371 9.633 9.643-9.633m2.87 9.633 9.643-9.633m2.87 9.633 9.644-9.633m2.87 9.633 9.643-9.633",
    stroke: "#919499"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919499",
    fillRule: "nonzero",
    d: "M51 33h156v1H51z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCallSkeleton);
var _default = exports["default"] = Memo;